import React from "react";

import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavItem from "react-bootstrap/NavItem";
import Container from "react-bootstrap/Container";

import HeadStripe from "./HeadStripe";
import KVALogoWide from "./KVALogoWide";
import OpenSource from "./OpenSource";

import { LinkContainer } from "react-router-bootstrap";

import { getUserData } from "../sessionStorage";

function helloLine(): any {
  const userData = getUserData();

  if (userData == null) {
    return "Willkommen!";
  }

  const decoded = JSON.parse(userData);

  return <>{`Willkommen ${decoded.fullName}`}</>;
}

export default function Menu(props: any) {
  return (
    <>
      <div className="mobile_device_blocker">
        <div className="hint-wrapper">
          <div className="p-1">
            <KVALogoWide />
          </div>
          <div className="p-1">
            <h4>
              Diese Webseite ist nicht für Mobilgeräte angelegt. Bitte benutzen
              Sie ein Tablet oder einen Desktoprechner!
            </h4>
          </div>
        </div>
      </div>
      <Navbar
        bg="light"
        variant="light"
        fixed="top"
        expand={"lg"}
        style={{ zIndex: 1000 }}
      >
        <Container fluid className="d-block pl-0 pr-0 align-items-center">
          <HeadStripe helloLine={helloLine()} />
          <Navbar.Collapse id="navbarResponsive">
            <Nav className="ml-auto" as="ul">
              <LinkContainer exact to="/">
                <NavItem as="li">
                  <Nav.Link href="/">
                    Startseite
                    <span className="icon-home ml-2" />
                  </Nav.Link>
                </NavItem>
              </LinkContainer>
              <LinkContainer to="/account">
                <NavItem as="li">
                  <Nav.Link href="/account">
                    Mein Profil
                    <span className="icon-user ml-2" />
                  </Nav.Link>
                </NavItem>
              </LinkContainer>
              <LinkContainer to="/vorgaenge">
                <NavItem as="li">
                  <Nav.Link href="/vorgaenge">
                    Meine Vorgänge
                    <span className="icon-list ml-2" />
                  </Nav.Link>
                </NavItem>
              </LinkContainer>
              <LinkContainer to="/buchungen">
                <NavItem as="li">
                  <Nav.Link href="/buchungen">
                    Buchungen
                    <span className="icon-list ml-2" />
                  </Nav.Link>
                </NavItem>
              </LinkContainer>
              <LinkContainer to="/nachrichten">
                <NavItem as="li">
                  <Nav.Link href="/nachrichten">
                    Mein Postfach
                    <span className="icon-inbox ml-2" />
                  </Nav.Link>
                </NavItem>
              </LinkContainer>
              <LinkContainer to="/kontakt">
                <NavItem as="li">
                  <Nav.Link href="/kontakt">
                    Kontakt
                    <span className="icon-mail ml-2" />
                  </Nav.Link>
                </NavItem>
              </LinkContainer>
              <LinkContainer to="/logout">
                <NavItem as="li">
                  <Nav.Link href="/logout">
                    Ausloggen
                    <span className="icon-logout ml-2" />
                  </Nav.Link>
                </NavItem>
              </LinkContainer>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className="mainframe">
        <div className="mainmenu" style={{ zIndex: 1000 }}>
          <div className="sidemenu">
            <div className="overheight">
              <Navbar
                className="desktop d-none d-md-block navbar-nav"
                as="ul"
                expand={"lg"}
              >
                <LinkContainer exact to="/">
                  <NavItem as="li">
                    <Nav.Link href="/">
                      <span className="txtwrap">Startseite</span>
                      <span className="icon-home ml-2" />
                    </Nav.Link>
                  </NavItem>
                </LinkContainer>
                <LinkContainer to="/account">
                  <NavItem as="li">
                    <Nav.Link href="/account">
                      <span className="txtwrap">Mein Profil</span>
                      <span className="icon-user ml-2" />
                    </Nav.Link>
                  </NavItem>
                </LinkContainer>
                <LinkContainer to="/vorgaenge">
                  <NavItem as="li">
                    <Nav.Link href="/vorgaenge">
                      <span className="txtwrap">Meine Vorgänge</span>
                      <span className="icon-list ml-2" />
                    </Nav.Link>
                  </NavItem>
                </LinkContainer>
                <LinkContainer to="/buchungen">
                  <NavItem as="li">
                    <Nav.Link href="/buchungen">
                      <span className="txtwrap">Buchungen</span>
                      <span className="icon-chart-bar ml-2" />
                    </Nav.Link>
                  </NavItem>
                </LinkContainer>
                <LinkContainer to="/nachrichten">
                  <NavItem as="li">
                    <Nav.Link href="/nachrichten">
                      <span className="txtwrap">Mein Postfach</span>
                      <span className="icon-inbox ml-2" />
                    </Nav.Link>
                  </NavItem>
                </LinkContainer>
                <LinkContainer to="/kontakt">
                  <NavItem as="li">
                    <Nav.Link href="/kontakt">
                      <span className="txtwrap">Kontakt</span>
                      <span className="icon-mail ml-2" />
                    </Nav.Link>
                  </NavItem>
                </LinkContainer>
                <LinkContainer to="/logout">
                  <NavItem as="li">
                    <Nav.Link href="/logout">
                      <span className="txtwrap">Ausloggen</span>
                      <span className="icon-logout ml-2" />
                    </Nav.Link>
                  </NavItem>
                </LinkContainer>
              </Navbar>
            </div>
          </div>
        </div>
        <div className="contact-sidebar-wrapper">
          <div className="contact-sidebar">
            <div className="contacter mail">
              <a
                href="#"
                onClick={() => props.history.push("/nachrichten/kontakt")}
              >
                <span className="txtwrap">Nachricht an uns</span>
                <span className="icon-chat-empty ml-2"></span>
              </a>
            </div>
            <div className="contacter phone">
              <a href="#" onClick={() => props.history.push("/kontakt")}>
                <span className="txtwrap">KVA Hotline</span>
                <span className="icon-phone ml-2"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <OpenSource />
    </>
  );
}
